// src/components/Skills.js
import React from 'react';

const Skills = () => {
  return (
    <section className="section skills">
      <h2>Skills</h2>
      <ul className="skills-list">
        <li>Programming Languages: Python, Java, C, JavaScript</li>
        <li>Frontend: HTML5, CSS3, React.js, Bootstrap</li>
        <li>Backend & Frameworks: Django</li>
        <li>Database: SQL</li>
        <li>Tools & Platforms: Git, GitHub, VS Code, Jupyter Notebook, PyCharm, Dev C++</li>
        <li>Testing: Manual Testing, Test Case Design, Jira, Selenium (Basics)</li>
        <li>Concepts: Data Structures & Algorithms, Operating Systems, DBMS, Computer Networks</li>
        <li>Cloud: AWS (Beginner)</li>
        <li>Data Analysis: Power BI, Pandas, Matplotlib (Basics)</li>
        <li>Soft Skills: Problem Solving, Communication, Analytical Thinking, Teamwork</li>
      </ul>
    </section>
  );
};

export default Skills;
